import SlideAcross from './SlideAcross';

export default SlideAcross;
